module.exports = __webpack_public_path__ + "img/top.0bfd3831.png";